import React, {Component} from 'react';
import {BsyUtils} from "../../utils/Utils";
import { withRouter } from "react-router-dom";
import i18next from 'i18next';

class ApiDocFormContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            appList:[],
            formTypeCont : props.formTypeCont,
            app:{},
            success:false,
            CONST : {
                CREATE_FIELDS: ["text", "textarea", "number", "datetime", "radiogroup", "checkboxgroup", "combo", "combocheck", "address", "location","image", "subform", "phone", "user", "usergroup", "dept", "deptgroup"]
            }
        }
        // console.log(props.formTypeCont)
    }
    _genCode = (e, t) =>{
        if("json" === (t = t || "json")){
            e = JSON.stringify(e, null, 4);
        }
        return <pre><code className={t}>{e}</code></pre>
    }

    _genTable = (e) => {
        return <table className="api-table x-table-bordered x-table-striped">
            <tr>
                {
                    e.columns.map((res)=>{
                        return <th>{
                            res.text
                        }</th>
                    })
                }
            </tr>
            {
                e.data.map((res)=>{
                    return <tr>
                        {
                            e.columns.map((res1)=>{
                                return <td>{
                                    res[res1.key]
                                }</td>
                            })
                        }
                    </tr>
                })
            }
        </table>
    }

    _genUl = (e) => {
        return <ul className="api-ul">
            {
                e.map((res)=>{
                    return <li className="api-li">{res}</li>
                })
            }
        </ul>
    }

    switchVersion = (v,a,i) =>{
        return () =>{
            const {formTypeCont} = this.state;
            formTypeCont.map((res)=>{
                if(a === res.key){
                    i.version = v;
                    res = i
                }
            })
            this.setState({
                formTypeCont
            })
        }
    }

    _genApiTitle = (e, t, i, a) => {
        let v = i.detail.version ? i.detail.version[i.version] : '';
        var routUrl = window.root_directroy ? window.root_directroy + '/' : '';
        let url = v ? window._bby_config.api_site + routUrl + "openapi" + "/" + v + i.link : '';
        
        return <>
            <div className={"api-h1 " + a}>
                <p>{i.name}</p>
                {v && i.key !== 'app_data_field_list' && <div className="version">
                    <span className="versionLabel">
                        {React.language('version')}
                    </span>
                    <div className="versionList">
                        {
                            i.detail.version.map((res,key)=>{
                                return <div className={"versionItem " + (v === res ? "selected" : "")} onClick={this.switchVersion(key,a,i)}>
                                    {res}
                                </div>
                            })
                        }
                    </div>
                </div>}
                {url && i.key !== 'app_data_field_list' && <p>
                    <input readOnly="readonly" style={{"width": "80%","font-size": "16px","border": "none","color": "#666","padding-left": 0}} type="text" value={url} />
                    <a href="javascript:void(0)" className="copy" onClick={(event)=>{
                        event.currentTarget.previousSibling.select();
                        document.execCommand('Copy');
                    }}>{React.language("click.copy")}</a>
                </p>}
            </div>
            {
                i.desc && <div className="api-p" dangerouslySetInnerHTML={{__html:i.desc}}/>
            }
        </>
    }

    _getAliasOrName = (e) => {
        const FX = window.FX;
        return FX.Utils.isObjectEmpty(e) ? "" : e.alias || e.name || ""
    }
    
    _genReqAndRes = (t, i, a, s, n) => {
        let v = s.detail.version[s.version]
        let d = s.detail.info[v]
        return d.requestParams ? <>
            <div className="api-p" dangerouslySetInnerHTML={{__html:d.description}} />
            <div className="api-p">{d.requestParams.length > 0 ? React.language("api.req.params") : React.language('api.req.noParams')}</div>
            {
                d.requestParams.length > 0 && this._genTable({
                    columns: [{
                        key: "name",
                        text: React.language("params")
                    }, {
                        key: "require",
                        text: React.language("must")
                    }, {
                        key: "type",
                        text: React.language("type")
                    }, {
                        key: "description",
                        text: React.language("explain")
                    }],
                    data: d.requestParams
                })
            }
            <div className="api-p">{d.responseParams.length > 0 ? React.language("api.res.params") : React.language('api.res.noParams')}</div>
            {
                d.responseParams.length > 0 && this._genTable({
                    columns: [{
                        key: "name",
                        text: React.language("params")
                    }, {
                        key: "type",
                        text: React.language("type")
                    }, {
                        key: "description",
                        text: React.language("explain")
                    }],
                    data: d.responseParams
                })
            }
            <div className="api-p">{React.language("api.req.example")}</div>
            {
                this._genCode(JSON.parse(d.requestDemo))
            }
            <div className="api-p">{React.language("api.res.example")}</div>
            {
                this._genCode(JSON.parse(d.responseDemo))
            }
        </> : <>
            {
                d.length > 0 && this._genTable({
                    columns: [{
                        key: "title",
                        text: i18next.t('api.params.desc.title')
                    }, {
                        key: "widget",
                        text: i18next.t('field.widget.name')
                    }, {
                        key: "name",
                        text: i18next.t('api.widget.alias')
                    }, {
                        key: "type",
                        text: i18next.t('field.type')
                    }],
                    data: d
                })
            }
        </>
    }


    componentDidMount() {
        if(document.getElementById(this.props.match.params.entryId)){
            let l = document.getElementById(this.props.match.params.entryId).getElementsByTagName("ul")[0].getElementsByTagName("li").length;
            document.getElementById(this.props.match.params.entryId).getElementsByClassName("item")[0].classList.add("open");
            document.getElementById(this.props.match.params.entryId).getElementsByTagName("ul")[0].style.display = "block";
            document.getElementById(this.props.match.params.entryId).getElementsByTagName("ul")[0].style.height = (l * 36 + "px");
        }
        this.setState({
            success:true
        },()=>{
            document.getElementsByClassName("api-doc")[0].getElementsByClassName(this.props.match.params.type).length>0 && document.getElementsByClassName("api-doc")[0].scrollTo(0,document.getElementsByClassName("api-doc")[0].getElementsByClassName(this.props.match.params.type)[0].offsetTop);
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            formTypeCont : nextProps.formTypeCont,
        },()=>{
            document.getElementsByClassName("api-doc")[0].getElementsByClassName(nextProps.match.params.type).length>0 && document.getElementsByClassName("api-doc")[0].scrollTo(0,document.getElementsByClassName("api-doc")[0].getElementsByClassName(nextProps.match.params.type)[0].offsetTop) ;
        })
    }
    render() {
        let s = this.props.match.params.id;
        let i = this.props.match.params.entryId;
        let n = this.props.match.params.type;
        let _this = this;
        const {success, appList, formTypeCont} = this.state
        return (
            <div className="api-doc-content">
                {
                    success && formTypeCont.map((res, key) =>{
                        return <>
                            {
                                _this._genApiTitle(s, i, res, res.key)
                            }
                            {
                                _this._genReqAndRes(s, i, appList, res, res.key)
                            }
                        </>
                    })
                }
            </div>
        );
    }
}
export default withRouter(ApiDocFormContent)